import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import { AxiosRequestConfigMethods } from "@/api/types";
import { FiltersResponse } from "@/modules/common/dtos/index.v2";
import { AxiosResponse } from "axios";
import { Track } from "../../types";
import { TrackStatusFormField } from "../../dtos/property-stage";

export const getStatusesByTrackStage = async (
  id: number,
  rentalTag?: string
) => {
  const params = rentalTag ? `?rentalTag=${rentalTag}` : "";
  const apiUrl = brandUrl<FiltersResponse[]>(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/track-stages/${id}/track-statuses${params}`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  }) as Promise<AxiosResponse<FiltersResponse[]>>;
};

export const updateTrackStatus = async (uid: string, formData: FormData) => {
  const apiUrl = brandUrl<Track>(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/tracks/${uid}/update-status`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.PATCH,
      formData: true,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  }) as Promise<AxiosResponse<Track>>;
};

export const getStatusPropertyFields = async (statusId: number) => {
  const apiUrl = brandUrl<TrackStatusFormField[]>(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/statuses/${statusId}/property-fields`
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  });
};
